<template>
  <v-app-bar color="transparent" position="relative" class="appbar w-100" dark>
    <!-- سمت چپ: آیکون جستجو -->
    <div class="w-100 d-flex justify-content-between align-items-center">
      <!-- سمت راست: لوگو -->
      <img
        v-if="logo.length > 0"
        :src="logo"
        alt="لوگو"
        max-height="40"
        contain
        class="logo"
        style="cursor: pointer; border-radius: 100%; width: 40px; height: 40px"
      />
      <span v-else></span>

      <v-btn
        icon
        @click="showModal = true"
        class="search-icon"
        elevation="2"
        rounded
        width="40px"
        height="40px"
      >
        <v-icon md>mdi-magnify</v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
export default {
  name: "bAppBar",

  props: {
    value: Boolean,
    logo: [Array, Object, String],
  },

  computed: {
    showModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style scoped>
.appbar {
  width: 100% !important;
  background: rgba(187, 186, 186, 0.466) !important;
  display: flex;
  align-items: center;
  border-top-right-radius: 8px !important;
  border-top-left-radius: 8px !important;
}

.appbar >>> .v-toolbar__content {
  width: 100%;
}

.search-field {
  max-width: 400px;
  cursor: pointer;
}

.search-field input {
  cursor: pointer !important;
  user-select: none;
}

.search-field .v-input__control {
  border-radius: 24px;
  background-color: rgba(255, 255, 255, 0.15);
  transition: background-color 0.3s ease;
}

.search-field:hover .v-input__control {
  background-color: rgba(255, 255, 255, 0.3);
}
.search-icon {
  color: #ffca28; /* زرد طلایی برند ویوتیفای */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.search-icon:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(255, 202, 40, 0.7);
}
</style>
